/**
 * SaveExtractionDialog public entry point.
 * Re-exports the view component directly because the dialog itself is
 * pure — it does not own any state and is driven entirely by props
 * passed from {@link SaveExtractionSectionContainer}.
 * @module features/contracts/components/SaveExtractionDialog
 */
export { default } from "./SaveExtractionDialogView";
